import React from 'react';
import { MobileGuestMenu } from '../MobileGuestMenu';
import { MobileLoggedInMenu } from '../MobileLoggedInMenu';
import { useMobileViewContext } from '../../MobileView.provider';
import { IdentityWidgetContent } from '../../../IdentityWidget/components/IdentityWidgetContent';

export const MobileMainMenu: React.FC = () => {
  const { currentUser, eventId, onSwitchEventClick } = useMobileViewContext();
  return (
    <>
      {currentUser.profile && (
        <>
          <IdentityWidgetContent
            eventId={eventId}
            eventMemberships={currentUser.eventMemberships}
            profile={currentUser.profile}
            onSwitchEventClick={onSwitchEventClick}
          />
          <MobileLoggedInMenu />
        </>
      )}
      {!currentUser.profile && <MobileGuestMenu />}
    </>
  );
};
